import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import PartnerLicensePackageUsageRateTable from './PartnerLicensePackageUsageRateTable';
import { PartnerLicensePackageUsageRateListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';

class PartnerLicensePackageUsageRateDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerLicensePackageUsageRateListService.load();
  }

  render() {
    return (
      <PartnerLicensePackageUsageRateTable
        loading={
          PartnerLicensePackageUsageRateListService.fetchCurrent.fetching ||
          PartnerLicensePackageUsageRateListService.fetchPrevious.fetching
        }
        values={toJS(PartnerLicensePackageUsageRateListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={PartnerLicensePackageUsageRateListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={PartnerLicensePackageUsageRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerLicensePackageUsageRateDetailTableContainer);
